var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.total === 'number')?_c('span',{staticClass:"el-pagination__total"},[_vm._v("\n  "+_vm._s(_vm.t('el.pagination.total', {
      total: this.$numeral(this.$parent.total).format('0,0')
    }))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }